import { create_trigger } from '@/base/trigger'
export default {
  'lock': false,
  'hidden': false,
  'style': {
    'position': 'absolute',
    'width': 60,
    'height': 60,
    'left': 100,
    'top': 200,
    'border-radius': 0,
    'border-width': 0,
    'border-style': 'solid',
    'rotate': 0,
    'transform': 'rotate(0deg)',
    'border-color': '',
    'clip-path': 'none'
  },
  'link': null,
  filterType: 0,
  filter: {
    'brightness': 0,
    'contrast': 0,
    'saturate': 0,
    'hueRotate': 0,
    'blur': 0
  },
  clipShape: '',
  'fit': 'cover', // cover / fill
  'cmpType': 'block',
  'type': 'basic_block',
  'name': '区块02'
}
